import { render, staticRenderFns } from "./ModalEditReservationDetail.vue?vue&type=template&id=52fb71b6&scoped=true"
import script from "./ModalEditReservationDetail.vue?vue&type=script&lang=js"
export * from "./ModalEditReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalEditReservationDetail.vue?vue&type=style&index=0&id=52fb71b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb71b6",
  null
  
)

export default component.exports